import { render, staticRenderFns } from "./OldSubmitForm.vue?vue&type=template&id=2cf708c4&scoped=true&"
import script from "./OldSubmitForm.vue?vue&type=script&lang=js&"
export * from "./OldSubmitForm.vue?vue&type=script&lang=js&"
import style0 from "./OldSubmitForm.vue?vue&type=style&index=0&id=2cf708c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf708c4",
  null
  
)

export default component.exports